/**
 * 
 * 确认订单数据存储
 */
let initState = {
  checkedInfo: {},
  coupons: {},
  rightsProductCode: '',
}
const confirmOrderInfo = {
  state: {
    checkedInfo: {}, // 周边产品选中的信息
    coupons: {}, // 可用 不可用优惠券
    rightsProductCode: ''// 选中的权益包code
  },
  mutations: {
    setCheckedInfo:(state, data) => {
      state.checkedInfo = data
    },
    setCoupon:(state, data) => {
      state.coupons = data
    },
    setRights: (state, data) => {
      state.rightsProductCode = data
    },
    resetConfirmOrderInfo (state) {
      Object.keys(state).forEach(key => { state[key] = initState[key]})
    },
    
  },
  actions: {

  }
}

export default confirmOrderInfo



// WEBPACK FOOTER //
// ./src/store/confirmOrder.js